import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { sweetAlert } from '../../../utils/swal';
import {  getShiftDays } from 'src/app/utils/utils.common';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { DynamicFareServiceService } from '../dynamic-fare-service/dynamic-fare-service.service';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import * as moment from 'moment-timezone';
import { forkJoin } from 'rxjs';


@Component({
  selector: 'app-dynamic-fare-add',
  templateUrl: './dynamic-fare-add.component.html',
  styleUrls: ['./dynamic-fare-add.component.css']
})
export class DynamicFareAddComponent implements OnInit, OnDestroy {
  submitted = false;
  companies;
  fareForm: UntypedFormGroup;
  vehcileTypeForm: UntypedFormGroup;

  user;
  fareId;
  levelOfServiceList = [];
  spaceTypeList = [];
  spaceTypeMainList = [];
  fundingSourceList = [];
  daysList = getShiftDays;
  timeZone: any

  constructor(
    private corporateService: CorporateService,
    private levelOfServiceService: LevelOfServiceService,
    private dynamicFareService: DynamicFareServiceService,
    private sharedDataService: SharedDataService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: UntypedFormBuilder,
  ) { }

 async ngOnInit() {
    if (this.activatedRoute.snapshot.url.length === 3 && this.activatedRoute.snapshot.url[2].path === 'edit') {
        this.fareId = this.activatedRoute.snapshot.url[1].path;
      }

      this.fareForm = this.fb.group({
        cooperate: ['', Validators.required],
        company: ['',Validators.required],
        perMile: ['', Validators.required],
        perMin: ['', Validators.required],
        minimumFare: [''],
        cancelCharges: ['', Validators.required],
        additionalPassengerCharges: [''],
        noShowCharges: ['0', Validators.required],
        pickupSurcharge: this.fb.group({
          fare: [''],
          per: [''],
          after: ['']
        }),

        baseFare: this.fb.group({
          fare: ['', Validators.required],
          for: ['', Validators.required],
        }),

        waitTime: this.fb.group({
          fare: ['', Validators.required],
          per: ['', Validators.required],
          after: ['', Validators.required],
        }),

        isPerMileZone: [false],
        los: ['', Validators.required],
        spaceType: ['', Validators.required],
        preStartTime: [moment().startOf('day'), Validators.required],
        startTime: [moment().startOf('day').format("HH:mm"), Validators.required],
        preEndTime: [moment().endOf('day'), Validators.required],
        endTime: [moment().endOf('day').format("HH:mm"), Validators.required],
        days: [[], Validators.required],

        code: [""],
        perMileCode: [""],
        preUnLoadTime: [""],
        dryRunCode: [""],
        baseFareCode: [""],
        waitTimeCode: [""],
        weekendNightCode: [""],
        responseNightCode: [""],
        zones: this.fb.array([]),
        status: ["", Validators.required],


      });

      this.makeCompulsoryCalls();
  }

  makeCompulsoryCalls() {
    const requests = [
     this.getFundingSourceList(),
     this.getLevelOfService(),
     this.getSpaceTypeList(),
    ];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1, res2, res3]) => {

        if (res1) {
          this.fundingSourceList = res1;
        }
        if (res2) {
          this.levelOfServiceList = res2;
        }
        if (res3) {
          this.spaceTypeMainList = res3;
        }

        this.getUser();
      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  getFundingSourceList() {

    return this.corporateService.getCorporateUsers('active');
  }

  getLevelOfService() {

    return this.levelOfServiceService.getLevelOfServices({ status: 'active' });
  }

  getSpaceTypeList() {

    return this.levelOfServiceService.getSpaceTypes({ status: 'active' });
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(user => {
        this.user = user;
        this.timeZone = user.timeZone;

        this.fareForm.patchValue({
        company: this.user._id
        });

        if (this.fareId) {
          this.getDynamicFareById();
        }

      });
  }

  getDynamicFareById() {
    this.dynamicFareService
      .getDynamicFareById(this.fareId)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.fareForm.patchValue({
            ...data,

            preStartTime: moment().startOf('day').hours(data.startTime.split(":")[0]).minutes(data.startTime.split(":")[1]).seconds(0),
            preEndTime: moment().startOf('day').hours(data.endTime.split(":")[0]).minutes(data.endTime.split(":")[1]).seconds(0),

            startTime: moment().startOf('day').hours(data.startTime.split(":")[0]).minutes(data.startTime.split(":")[1]).seconds(0).format("HH:mm"),
            endTime: moment().startOf('day').hours(data.endTime.split(":")[0]).minutes(data.endTime.split(":")[1]).seconds(0).format("HH:mm"),

          });
          this.addZoneItem(data.zones);
          this.onSelectLOS(data.los);
        }
      });
  }


  toggleZonePerMile() {
    this.fareForm.patchValue({
      isPerMileZone: !this.fareForm.value.isPerMileZone
    });
  }

  get form() {
    return this.fareForm.controls;
  }

  get zonesForm() {
    return this.fareForm.get('zones') as UntypedFormArray;
  }

  onSelectLOS(losId) {
    this.spaceTypeList = [];
    if (!losId) {
      this.fareForm.patchValue({
        spaceType: ''
      });
      return;
    };

    this.spaceTypeList = this.spaceTypeMainList.filter(item => item.los === losId);
    const spaceTypes = this.spaceTypeList.filter(spaceTypeItem => spaceTypeItem._id === this.fareForm.value.spaceType);
    if (!spaceTypes.length) {
      this.fareForm.patchValue({
        spaceType: ''
      });
    }
  }

  setStartTimeChange(evt) {
    this.fareForm.patchValue({
      startTime : moment(evt).format("HH:mm"),
    });
  };

  setEndTimeChange(evt) {
    this.fareForm.patchValue({
      endTime : moment(evt).format("HH:mm"),
    });
  }


    addZoneItem(preZoneList?) {
      const items = this.fareForm.get('zones') as UntypedFormArray;

      if (preZoneList) {
        for (const zone of preZoneList) {
          items.push(
            this.fb.group({
              fare: [zone.fare, [Validators.required]],
              from: [zone.from, [Validators.required]],
              to: [zone.to, [Validators.required]],
            })
          );

        }
        return;
      }

      // if (!items.invalid) {
      items.push(
        this.fb.group({
          // baseFare: ['', Validators.required],
          fare: ['', [Validators.required]],
          from: ['', [Validators.required]],
          to: ['', [Validators.required]],
        })
      );
      // }
    }

    removeZoneItem(index: any) {
      const items = this.fareForm.get('zones') as UntypedFormArray;
      items.removeAt(index);
    }

  onSubmit() {
    this.submitted = true;
    if (this.fareForm.invalid) {
      return;
    }

    this.dynamicFareService
      .saveDynamicFare(this.fareForm.value, this.fareId)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.router.navigateByUrl('rates');
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  ngOnDestroy(): void {
  }

  getMinDate() {
    return moment().startOf('day');
  }
  getMaxDate() {
    return moment().endOf('day');
  }

  getStartMinDate(val) {
    return moment(val);
  }
}
